/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/loading"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {  
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2800 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Boumaden",
  title: "Bonjour à tous, je suis Abdennour Boumaden ",
  subTitle: emoji(
    "Développeur Full Stack passionné 🚀 avec de l'expérience dans la création d'applications Web et Mobiles en Java, JavaScript, PHP, Laravel, C++ et C, ainsi qu'avec d'autres bibliothèques et frameworks modernes."),
  resumeLink:
    "https://drive.google.com/file/d/1-Qn5yJ7rFcKYg-IUTlmgXYLUcdmUJv1s/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links
// To customize icons and social links, tweak src/components/SocialMedia
const socialMediaLinks = {
  github: "https://github.com/Niromali",
  linkedin: "https://www.linkedin.com/in/abdennour-boumaden/",
  gmail: "boumadenn.abdennour@gmail.com",
  //gitlab: "https://gitlab.com/saadpasta",
  facebook: "https://web.facebook.com/ni.roo.77",
  twitter: "https://twitter.com/Abdennourboumad",
  instagram: "https://www.instagram.com/reddnom/",
  upwork : "https://www.upwork.com/freelancers/~01c734ee31bdaec01e",
  // Instagram, Twitter and Kaggle are also supported in the links!
  
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Ce que je fais ",
  subTitle: "Je suis un développeur Full Stack curieux et audacieux, toujours prêt à plonger dans de nouvelles technologies ! ",
  skills: [
    emoji(
      "⚡ Concevoir des interfaces utilisateur front-end/back-end attrayantes pour vos applications web et mobiles, riches en interactivité. "
    ),
    emoji("⚡ Créer des Applications Web Progressives (PWA) pour des stacks traditionnelles et des applications à page unique (SPA). "),
    emoji(
      "⚡ Créer un script pour tout site web afin de développer votre travail. "
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Php",
      fontAwesomeClassname: "fab fa-php"
    },
    {
      skillName: "Laravel",
      fontAwesomeClassname: "fab fa-laravel"
    },
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },

    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },

  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      
      schoolName: "Ecole Polytechnique des Génies - EPG",
      logo: require("./assets/images/epg.png"),
      subHeader: " LICENCE PROFESSIONNELLE : ADMINISTRATION DE BASE DE DONNÉES & TECHNOLOGIES WEB",
      duration: "Septembre 2022 - Avril 2023",
      desc: "Développement avec les nouvelles technologies et cybersécurité",
      descBullets: [
        "Développement d'applications mobiles et de bureau",
        "Cybersécurité et commandes Linux",
        "Développement de projets"
      
      ]
    },

    {
      schoolName: "Classe préparatoire du Brevet de Technicien Supérieur",
      logo: require("./assets/images/téléchargement.png"),
      subHeader: "Diplôme : Technico-commercial",
      duration: "Septembre 2020 - Avril 2022",
      desc: "Études des techniques commerciales et du développement de bases de données",
      descBullets: [
        "Techniques de négociation",
        "Relation client",
        "Développement de projets"
      ]
      
    },
    {
      schoolName: "Lycée Technique - Fès",
      logo: require("./assets/images/apercu_logo_lycee.png"),
      subHeader: "Baccalauréat en sciences et technologies mécaniques",
      duration: "Année scolaire 2018-2019",
      desc: "Participation à la recherche en sciences mécaniques et en génie mécanique",
      
      descBullets: [
        //"Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        //"Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },

  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Wordpress",
      progressPercentage: "90%"
    },
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "50%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programmation | Apps Desktop",
      progressPercentage: "80%"
    }
    
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
            role: "Développement API & WordPress",
      company: "GEO Technologie et Innovation",
      companylogo: require("./assets/images/geo Logo.png"),
      date: "Mai 2023 – Juillet 2023",
      desc: "Création d'une application de surveillance et d'un site WordPress.",
      descBullets: [
        "Création d'une application de surveillance avec PHP (API).",
        "Création d'un site WordPress pour une location de voitures."
      ]

    },
    {
      role: "Développement Web",
      company: "EPG",
      companylogo: require("./assets/images/epg.png"),
      date: "Mai 2023 – Juillet 2023",
      desc: "Création et développement de 3 sites e-commerce",
      descBullets: [
        "J'ai utilisé WordPress et Local.",
        "3 sites e-commerce avec différents plugins et thèmes"
      ]

    },
    {
      role: "Développement en Java",
      company: "Innovaya Consulting",
      companylogo: require("./assets/images/innovaya.png"),
      date: "Août 2021 – Septembre 2021",
      desc: "Développement avec le langage Java",
      descBullets: [
        "Application Socket avec toutes les options.",
        "Application de gestion scolaire."
      ]
      
    },
    {
      role: "Technicien de bureau",
      company: "Saiss Equipement",
      companylogo: require("./assets/images/saiss.png"),
      date: "Mai 2021 – Juin 2021 (Fès, Maroc)",
      desc: "Gestionnaire des opérations de bureau",
      descBullets: [
        "Création et mise en forme de documents.",
        "Gestion des données et des tableaux."
      ]
      
    },
    {
      role: "Administratif IT",
      company: "Saiss Equipement",
      companylogo: require("./assets/images/saiss.png"),
      date: "Mai 2020 – Juin 2020 (Fès, Maroc)",
      desc: "Gestion administrative des infrastructures IT",
      descBullets: [
        "Installer, configurer et maintenir les logiciels et systèmes informatiques.",
        "Créer et maintenir la documentation sur les procédures et les normes informatiques."
      ]

    },



  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

// Some big projects you have worked on

const bigProjects = {
  title: "Grands Projets",
subtitle: "DES STARTUPS ET ENTREPRISES À QUI J'AI AIDÉ À CRÉER LEUR TECHNOLOGIE",
projects: [
        {
          image: require("./assets/images/saayaHealthLogo.webp"),
          projectName: "Saayahealth",
          projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
          footerLink: [
            {
              name: "Visiter le site",
              url: "http://saayahealth.com/"
            }
            // Vous pouvez ajouter des boutons supplémentaires ici.
          ],

      photos: [
        require("./assets/images/epg.png"),
        require("./assets/images/epg.png"),
        require("./assets/images/epg.png")
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ],
      photos: [
        require("./assets/images/epg.png"),
        require("./assets/images/epg.png")
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Réalisations et Certifications 🏆 "),
subtitle:
  "Réalisations, Certifications, Lettres de prix et Quelques superbes choses que j'ai faites !",

achievementsCards: [
  {
    title: "Certificat de Développement",
    subtitle:
      "Meilleures pratiques de développement à l'EPG",
  
      image: require("./assets/images/CertiDev.PNG"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Voir le Certificat",
          url: "https://epg.ma/Certificats/BOUMADEN%20Abdennour/BoumadenAbdennour-LicenceProfessionnelAdministrationBasesDeDonn%C3%A9e&TechnologiesWeb-BALPABDTW2.pdf"
        },

      ]
    },
    {
      title: "Certificat d'Excellence",
      subtitle:
        "L'intelligence et l'innovation de la technologie moyenne permettent de trouver le bon résultat.",
      image: require("./assets/images/CertiExele.PNG"),
      imageAlt: "Logo Google Assistant Action",
      footerLink: [
        {
          name: "Voir le Certificat",


          url: "https://epg.ma/Certificats/BOUMADEN%20Abdennour/BoumadenAbdennour-LicenceProfessionnelAdministrationBasesDeDonn%C3%A9e&TechnologiesWeb-BALPABDTW1.pdf"
        },
        {
          name: "EPG",
          url: "https://www.epg.ma/"
        },
      ]
    },

    {
            title: "Certificat de Persévérance",
      subtitle: "Le respect, la présence et le sérieux sont les clés du succès pour obtenir ce certificat.",
      image: require("./assets/images/CertiPer.PNG"),
      imageAlt: "Logo PWA",

      footerLink: [
        {name: "View Certificat", url: "https://epg.ma/Certificats/BOUMADEN%20Abdennour/BoumadenAbdennour-LicenceProfessionnelAdministrationBasesDeDonn%C3%A9e&TechnologiesWeb-BALPABDTW3.pdf"},

      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Grands Projets",
subtitle: "Passionné par la création, le partage et l'enseignement de l'art des créations géniales.",

  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://github.com/Niromali/Project_ExtractData-Form-webSite",
      title: "Projets Java ExtractData-Form-webSite",
      description: "Il s'agit d'un projet Java où un script extrait toutes les données d'un site web et les importe dans une base de données."
    },
    {
      url: "https://github.com/Niromali/Project-Gestion-Etudiant",
      title: "Pourquoi C++ est-il le meilleur ? 👀 Découvrez mon projet",
      description: "Il convient de noter que ce qui fait qu'un langage de programmation est 'le meilleur' peut être très subjectif et dépend du contexte ainsi que des exigences spécifiques d'un projet."
},
    {
      url: "https://github.com/Niromali/Project_Android",
      title: "Projets Android",
      description: "Alors que je continue de m'engager dans des projets Android, j'attends avec impatience l'opportunité de créer des solutions mobiles innovantes et axées sur l'utilisateur."
       },
    {
      url: "https://github.com/Niromali?tab=repositories",
      title: "Voir Plus de Projets 👌 Laravel Java C++ ...",
      description: "Découvrez le travail exceptionnel réalisé dans le domaine du développement Java et témoignez de la puissance de ces projets de première main, et découvrez-en plus sur moi."
      },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE  TO TALK ABOUT MYSELF AND TECHNOLOGY 😅",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://podcasters.spotify.com/pod/show/codevcast/embed/episodes/About-me-e2b3sil/"
  ],
  
  display: false // Set false to hide this section, defaults to true
};


const contactInfo = {
  title: emoji("Contactez-moi ☎️"),
  subtitle: "Vous avez un projet en tête ou vous souhaitez simplement échanger ? Ma boîte de réception vous accueille !",
  
  number: "+212697277104",
  email_address: "boumadenn.abdennour@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "Abdennourboumad",
  display: false
};

const isHireable = "Yes"; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
